import React, { useContext } from "react";
import styles from "./PriceIndication.module.scss";
import {
  createPriceIndicationTable,
  submitQuesRecalculate,
} from "./utils/utils";
import { LibertateContext } from "../../../../context/Context";
import { isExistingBusiness } from "../../../../utils/fieldAccess";
import { shouldDisableActionButton } from "../../../../utils/buttonDisableFun";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton } from "@mui/material";
function PriceIndication({
  data,
  selectedCarrier,
  overridesMap,
  updateOverridesMap,
}) {
  console.log("selectedCarrier:", selectedCarrier);

  const {
    overridesMap: updatedOverridesMap,
    pricingToolData: updatedPricingData,
    retainChecked,
    prePricingIndicationData,
    prevoverridesMap,
    calculateClicked,
  } = useContext(LibertateContext);

  const { classCodeTableData } = data || {};

  console.log("Selected Carrier", selectedCarrier);
  const carrierSwapData =
    updatedPricingData?.priceIndicationData?.carrierRateSwitchData?.[
      selectedCarrier
    ];

  const carrierSwapMessage =
    Array.isArray(carrierSwapData) && carrierSwapData.length > 0
      ? carrierSwapData[0]?.message
      : "";

  const getActiveOverridesMap = () => {
    if (overridesMap && Object.keys(overridesMap).length > 0) {
      return overridesMap;
    }
    if (updatedOverridesMap && Object.keys(updatedOverridesMap).length > 0) {
      return updatedOverridesMap;
    }
    return {};
  };

  const recalculateQuote = async () => {
    try {
      let targetMap = retainChecked ? prevoverridesMap : getActiveOverridesMap();
      let _overridesMap = JSON.parse(JSON.stringify(targetMap || {}));
      console.log("_overridesMap:", _overridesMap);

      let _preoverridesMap = JSON.parse(
        JSON.stringify(updatedOverridesMap || {}),
      );
      console.log("_preoverridesMap:", _preoverridesMap);

      let _prePricingToolData = JSON.parse(
        JSON.stringify(updatedPricingData || {}),
      );
      console.log("_prePricingToolData:", _prePricingToolData);

     
      let activeCarrier = selectedCarrier;

      if (_overridesMap && activeCarrier) {
        _overridesMap.selectedCarrier = activeCarrier;
      }

      // if activeCarrier doesn't exist in target map, fall back
      if (!_overridesMap.carrierDependent?.[activeCarrier]) {
        activeCarrier = selectedCarrier;
        _overridesMap = JSON.parse(JSON.stringify(getActiveOverridesMap() || {}));
      }

      if (
        activeCarrier &&
        _overridesMap?.carrierDependent?.[activeCarrier]?.overallModifiers
      ) {
        let brokerList =
          _overridesMap.carrierDependent[activeCarrier].overallModifiers
            .brokerList;
        if (brokerList) {
          if (
            brokerList.length > 1 &&
            !brokerList[brokerList.length - 1]?.name
          ) {
            brokerList.pop();
          }
          brokerList = brokerList.filter(
            (broker) => broker.name && broker.name.trim() !== "",
          );
          _overridesMap.carrierDependent[activeCarrier].overallModifiers.brokerList =
            brokerList;
        }
      }

      await submitQuesRecalculate(
        _overridesMap,
        _preoverridesMap,
        _prePricingToolData,
        activeCarrier,
      );
    } catch (error) {
      console.log("Error in recalculateQuote:", error);
    }
  };

  let fallbackCarrier = "";
  for (let carrier in classCodeTableData) {
    fallbackCarrier = carrier;
    break;
  }

  return (
    <section className={styles.indicationSection}>
      <div className="pink-header p-0 bg-white align-items-center">
        <div className="font-family-montserrat-bold headings">
          Price Indication
        </div>
      </div>
      <div className={`sectionContent ${styles.sectionContent}`}>
        <div className={`${styles.tableContainer} tableContainer`}>
          {createPriceIndicationTable(
            classCodeTableData?.[selectedCarrier || fallbackCarrier],
            retainChecked ? prevoverridesMap : getActiveOverridesMap(),
            prevoverridesMap,
            updateOverridesMap,
            selectedCarrier, // Carrier always from current session
            styles,
            retainChecked,
            calculateClicked,
          )}
          {carrierSwapMessage && (
            <>
              <div className="d-flex align-items-center">
                <div>
                  {" "}
                  <IconButton
                    sx={{
                      cursor: "default",
                      "&:hover": {
                        backgroundColor: "transparent",
                        cursor: "default",
                      },
                      "& svg": {
                        color: "black",
                        fontSize: "18px",
                        marginTop: "-1px",
                      },
                    }}
                  >
                    <InfoOutlinedIcon />
                  </IconButton>
                </div>
                <div className={styles.rateSwitchMessage}>
                  {carrierSwapMessage}
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.actionButtons}>
          <div className={`${styles.calculateSection}`}>
            <button
              className={`btn btn-warning btn-lg btn-warning-shadow btnSubmits`}
              disabled={
                !selectedCarrier ||
                (shouldDisableActionButton() && isExistingBusiness())
              }
              label={!selectedCarrier && "Select a carrier"}
              onClick={recalculateQuote}
            >
              Calculate
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(PriceIndication);
